import React from 'react'
import type { DecorationsProps } from '../types'
export const Decorations: React.FC<DecorationsProps> = () => null
